import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PerfectScrollbarModule } from '@farris/ui-perfect-scrollbar';
import { AngularDraggableModule } from '@farris/ui-draggable';

import { ModalBackdropComponent } from './modal-backdrop.component';
import { ModalDirective } from './modal.directive';
import { ModalContainerComponent } from './modal-container.component';
import { BsModalService } from './bs-modal.service';
import { PositioningService } from '@farris/ui-modal/positioning';
import { ComponentLoaderFactory } from '@farris/ui-modal/component-loader';
import { ModalButtonDirective } from './modal-button.directive';
import{FAreaResponseModule} from '@farris/ui-area-response';
import { FarrisTooltipModule } from '@farris/ui-tooltip';
import {ModalPositionSnapComponent} from './modal-position-snap.component';
@NgModule({
    imports: [
        CommonModule,
        PerfectScrollbarModule,
        AngularDraggableModule,
        FAreaResponseModule,
        FarrisTooltipModule
    ],
    declarations: [
        ModalDirective,
        ModalBackdropComponent,
        ModalContainerComponent,
        ModalButtonDirective,
        ModalPositionSnapComponent
    ],
    exports: [
        ModalBackdropComponent, ModalDirective,ModalPositionSnapComponent
    ],
    entryComponents: [ModalBackdropComponent, ModalContainerComponent]
})
export class ModalModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ModalModule,
            providers: [
                ComponentLoaderFactory,
                BsModalService,
                PositioningService
            ]
        };
    }
}
